import type { Coord } from "@dailywars/core/engine";

import type { CanvasMoveAnimation } from "#/game/animation/types";
import { FAST_PLAYBACK_SPEED_MULTIPLIER } from "#/game/constants";

export function buildPreviewAnimation({
  unitId,
  from,
  path,
  fastPlayback = false,
}: {
  unitId: string;
  from: Coord;
  path: Coord[];
  fastPlayback?: boolean;
}): CanvasMoveAnimation {
  const nowMs = typeof performance !== "undefined" ? performance.now() : 0;
  const baseDurationMs = Math.max(180, path.length * 130);
  const multiplier = fastPlayback ? FAST_PLAYBACK_SPEED_MULTIPLIER : 1;
  return {
    type: "move",
    unitId,
    from,
    path,
    startedAtMs: nowMs,
    durationMs: Math.max(1, Math.round(baseDurationMs / multiplier)),
  };
}
